"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class Category {
}
exports.default = Category;
//# sourceMappingURL=Category.js.map